import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIAddressLocation, LazyIAltStar, LazyIAppleStore, LazyIAspectRatioIcon, LazyICalendarAlt, LazyICalendarBlank, LazyICampaignStar, LazyICheck, LazyICheckmarkCard, LazyICheckmark, LazyIChevronDown, LazyIChevronLeft, LazyIChevronRight, LazyIChevronUp, LazyIChevronsDown, LazyIChevronsLeft, LazyIChevronsRight, LazyIChevronsUp, LazyICircleExclamation, LazyICircleLineConnector, LazyICity, LazyIClassicCalendarAlt, LazyIClock, LazyIClosebutton, LazyICloudPercentage, LazyICross, LazyICrown, LazyIDashedSquare, LazyIDiscounted, LazyIDollarCheck, LazyIExclamation, LazyIExpand2, LazyIExpand, LazyIFlagSwe, LazyIFriends, LazyIGoogleStore, LazyIHandHoldHeart, LazyIHeadphoneUser, LazyIHeartBlack, LazyIHeartDark, LazyIHeartGrey, LazyIHeartPink, LazyIHeartRed, LazyIHeartWhite, LazyIHorizontalDashedLine, LazyIIncluded, LazyIInfoSafety, LazyIInfoSatisfaction, LazyIInfoWorld, LazyIInfo, LazyIMapmarkerBlueNew, LazyIMapmarkerBlueSimple, LazyIMapmarkerBlueWPin, LazyIMapmarkerBlueWStar, LazyIMapmarkerBlue, LazyIMapmarkerYellowWStar, LazyIMapmarkerYellow, LazyIMappoint, LazyIMappointsRoute, LazyIMarker, LazyIMastercard, LazyINoOpinionSelected, LazyINoOpinion, LazyIPeopleGroup, LazyIPeople, LazyIPersonHikeSpruceSnowing, LazyIPlaneBusHotel, LazyIPlaneDeparture, LazyIPlayButton, LazyIQuestmark404, LazyIRotateRightOne, LazyISearchIcon, LazyIShare, LazyISinglesButton, LazyISolDown, LazyISolresorEmpty, LazyISolresorFull, LazyISolresorHalf, LazyISolresorIcon, LazyISpinner, LazyIStarEmpty, LazyIStarFull, LazyIStarHalf, LazyISuitcaseNo, LazyISuitcaseYes, LazyISwish, LazyITagEnd, LazyITravelExpert, LazyITripadvisorLogo, LazyITubeSpinner, LazyITwistedArrowRightToTopIcon, LazyIValue, LazyIVerticalDashedLine, LazyIVisa, LazyIWave, LazyIX } from '#components'
const lazyGlobalComponents = [
  ["IAddressLocation", LazyIAddressLocation],
["IAltStar", LazyIAltStar],
["IAppleStore", LazyIAppleStore],
["IAspectRatioIcon", LazyIAspectRatioIcon],
["ICalendarAlt", LazyICalendarAlt],
["ICalendarBlank", LazyICalendarBlank],
["ICampaignStar", LazyICampaignStar],
["ICheck", LazyICheck],
["ICheckmarkCard", LazyICheckmarkCard],
["ICheckmark", LazyICheckmark],
["IChevronDown", LazyIChevronDown],
["IChevronLeft", LazyIChevronLeft],
["IChevronRight", LazyIChevronRight],
["IChevronUp", LazyIChevronUp],
["IChevronsDown", LazyIChevronsDown],
["IChevronsLeft", LazyIChevronsLeft],
["IChevronsRight", LazyIChevronsRight],
["IChevronsUp", LazyIChevronsUp],
["ICircleExclamation", LazyICircleExclamation],
["ICircleLineConnector", LazyICircleLineConnector],
["ICity", LazyICity],
["IClassicCalendarAlt", LazyIClassicCalendarAlt],
["IClock", LazyIClock],
["IClosebutton", LazyIClosebutton],
["ICloudPercentage", LazyICloudPercentage],
["ICross", LazyICross],
["ICrown", LazyICrown],
["IDashedSquare", LazyIDashedSquare],
["IDiscounted", LazyIDiscounted],
["IDollarCheck", LazyIDollarCheck],
["IExclamation", LazyIExclamation],
["IExpand2", LazyIExpand2],
["IExpand", LazyIExpand],
["IFlagSwe", LazyIFlagSwe],
["IFriends", LazyIFriends],
["IGoogleStore", LazyIGoogleStore],
["IHandHoldHeart", LazyIHandHoldHeart],
["IHeadphoneUser", LazyIHeadphoneUser],
["IHeartBlack", LazyIHeartBlack],
["IHeartDark", LazyIHeartDark],
["IHeartGrey", LazyIHeartGrey],
["IHeartPink", LazyIHeartPink],
["IHeartRed", LazyIHeartRed],
["IHeartWhite", LazyIHeartWhite],
["IHorizontalDashedLine", LazyIHorizontalDashedLine],
["IIncluded", LazyIIncluded],
["IInfoSafety", LazyIInfoSafety],
["IInfoSatisfaction", LazyIInfoSatisfaction],
["IInfoWorld", LazyIInfoWorld],
["IInfo", LazyIInfo],
["IMapmarkerBlueNew", LazyIMapmarkerBlueNew],
["IMapmarkerBlueSimple", LazyIMapmarkerBlueSimple],
["IMapmarkerBlueWPin", LazyIMapmarkerBlueWPin],
["IMapmarkerBlueWStar", LazyIMapmarkerBlueWStar],
["IMapmarkerBlue", LazyIMapmarkerBlue],
["IMapmarkerYellowWStar", LazyIMapmarkerYellowWStar],
["IMapmarkerYellow", LazyIMapmarkerYellow],
["IMappoint", LazyIMappoint],
["IMappointsRoute", LazyIMappointsRoute],
["IMarker", LazyIMarker],
["IMastercard", LazyIMastercard],
["INoOpinionSelected", LazyINoOpinionSelected],
["INoOpinion", LazyINoOpinion],
["IPeopleGroup", LazyIPeopleGroup],
["IPeople", LazyIPeople],
["IPersonHikeSpruceSnowing", LazyIPersonHikeSpruceSnowing],
["IPlaneBusHotel", LazyIPlaneBusHotel],
["IPlaneDeparture", LazyIPlaneDeparture],
["IPlayButton", LazyIPlayButton],
["IQuestmark404", LazyIQuestmark404],
["IRotateRightOne", LazyIRotateRightOne],
["ISearchIcon", LazyISearchIcon],
["IShare", LazyIShare],
["ISinglesButton", LazyISinglesButton],
["ISolDown", LazyISolDown],
["ISolresorEmpty", LazyISolresorEmpty],
["ISolresorFull", LazyISolresorFull],
["ISolresorHalf", LazyISolresorHalf],
["ISolresorIcon", LazyISolresorIcon],
["ISpinner", LazyISpinner],
["IStarEmpty", LazyIStarEmpty],
["IStarFull", LazyIStarFull],
["IStarHalf", LazyIStarHalf],
["ISuitcaseNo", LazyISuitcaseNo],
["ISuitcaseYes", LazyISuitcaseYes],
["ISwish", LazyISwish],
["ITagEnd", LazyITagEnd],
["ITravelExpert", LazyITravelExpert],
["ITripadvisorLogo", LazyITripadvisorLogo],
["ITubeSpinner", LazyITubeSpinner],
["ITwistedArrowRightToTopIcon", LazyITwistedArrowRightToTopIcon],
["IValue", LazyIValue],
["IVerticalDashedLine", LazyIVerticalDashedLine],
["IVisa", LazyIVisa],
["IWave", LazyIWave],
["IX", LazyIX],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
